import type { BloomMobileLayoutItem } from '@jane/business-admin/types';

export const MOBILE_LAYOUT_LABELS: Record<BloomMobileLayoutItem, string> = {
  calls_to_action: 'Call-to-action',
  social_links: 'Social media',
  links: 'Links',
  image: 'Image',
  text: 'Text',
};

export const DEFAULT_MOBILE_LAYOUT: BloomMobileLayoutItem[] = [
  'calls_to_action',
  'social_links',
  'links',
  'image',
  'text',
];
